/**
 * Formata o nome da entidade seguindo o padrão do portal
 * Separa o tipo (PREFEITURA MUNICIPAL, CÂMARA MUNICIPAL) do nome da cidade
 */
export interface EntityDisplay {
  type: string;
  name: string;
  fullName: string;
}

export const formatEntityName = (entityName?: string): EntityDisplay => {
  if (!entityName) {
    return {
      type: '',
      name: '',
      fullName: ''
    };
  }

  const upperName = entityName.toUpperCase();

  // Verifica se é Prefeitura (tipo 1)
  if (upperName.includes('PREFEITURA')) {
    const cityName = upperName.replace('PREFEITURA MUNICIPAL DE', '').trim();
    return {
      type: 'PREFEITURA MUNICIPAL',
      name: cityName,
      fullName: `PREFEITURA MUNICIPAL DE ${cityName}`
    };
  }

  // Verifica se é Câmara (tipo 2)
  if (upperName.includes('CÂMARA') || upperName.includes('CAMARA')) {
    const cityName = upperName.replace(/CÂMARA MUNICIPAL DE|CAMARA MUNICIPAL DE/i, '').trim();
    return {
      type: 'CÂMARA MUNICIPAL',
      name: cityName,
      fullName: `CÂMARA MUNICIPAL DE ${cityName}`
    };
  }

  // Outros tipos - retorna o nome completo em maiúsculas
  return {
    type: '',
    name: upperName,
    fullName: upperName
  };
};

/**
 * Retorna apenas o nome formatado sem o tipo
 */
export const getEntityCityName = (entityName?: string): string => {
  return formatEntityName(entityName).name;
};

/**
 * Retorna o nome completo formatado
 */
export const getEntityFullName = (entityName?: string): string => {
  return formatEntityName(entityName).fullName;
};
